import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { IPostit } from '../interfaces';
import { ApiService } from '../services/api.service';


@Component({
  selector: 'app-postit',
  templateUrl: './postit.component.html',
  styleUrls: ['./postit.component.scss'],
  providers: [ApiService],
})
export class PostitComponent implements OnInit {

	postit : IPostit = {};

  constructor(
    private _api: ApiService,
  	private route: ActivatedRoute,
  ) { }

  ngOnInit() {
  	this.route
    .params
    .subscribe(
      (params: Params) => {
      	this.postit.uuid = params.uuid;
      	this.getPostit();
      })
  }

  getPostit() {
  	this._api.publicPostits
  	.retrieve(this.postit.uuid)
  	.subscribe(
  		(data) => {
  			this.postit = data;
  			console.log(this.postit);
  		},
  		(err) => {
  			console.log(err);
  		})
  }

}



// WEBPACK FOOTER //
// /mnt/disk/stratbox.dev/src/app/postit/postit.component.ts